import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
} from "@mui/material";
import { getCareRecordHistory } from "./sourceLifecycleService";

const CareRecordHistoryButton = ({ entry = {} }) => {
  const [open, setOpen] = useState(false),
    [items, setItems] = useState([]),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(false);
  const show = async () => {
    setOpen(true);
    setLoading(true);
    setError("");
    try {
      const result = await getCareRecordHistory({
        id: entry.id,
        collection: entry.collection || "dailyLogs",
      });
      setItems(result.items || []);
    } catch (failure) {
      setError(failure.message || "History could not be loaded.");
    } finally {
      setLoading(false);
    }
  };
  if (!entry.id) return null;
  return (
    <>
      <Button size="small" onClick={show}>
        View edit history
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Entry history</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            {loading ? <Typography>Loading history…</Typography> : null}
            {error ? <Alert severity="error">{error}</Alert> : null}
            {!loading && !error && !items.length ? (
              <Typography>
                No saved revisions are available for this entry. Its original
                capture is retained.
              </Typography>
            ) : null}
            {items.map((item) => (
              <Stack key={item.id} spacing={0.5}>
                <Typography variant="subtitle2">
                  {item.operation === "delete" ||
                  item.operation === "delete_story"
                    ? "Deleted"
                    : "Changed"}{" "}
                  by {item.actorName || "a care team member"} ·{" "}
                  {new Date(item.changedAt).toLocaleString()}
                </Typography>
                <Typography variant="body2">
                  Before: {item.before.text}
                </Typography>
                <Typography variant="body2">
                  After:{" "}
                  {item.after.status === "deleted"
                    ? "Removed from Timeline"
                    : item.after.text}
                </Typography>
                <Typography variant="caption">
                  {[
                    item.before.localDate,
                    item.before.localTime,
                    item.before.category,
                  ]
                    .filter(Boolean)
                    .join(" · ") || "Date not recorded"}{" "}
                  →{" "}
                  {[
                    item.after.localDate,
                    item.after.localTime,
                    item.after.category,
                  ]
                    .filter(Boolean)
                    .join(" · ") || "Date not recorded"}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default CareRecordHistoryButton;
